import cx from "classnames";
// import Hls from 'hls.js'
import Logger from "js-logger";
import React, { Component } from "react";
import { isIOS } from "react-device-detect";
// import { isMobile } from "react-device-detect";
// import ReactPlayer from 'react-player';
import ReactPlayer from "react-player/file";
import { connect } from "react-redux";

import "../../../node_modules/video.js/dist/video-js.min.css";
import AppConfig from "../../AppConfig";
import LoadingSpinner from "../../components/spinner/Spinner";
import * as Actions from "../../store/actions";
import * as PlayActions from "../../store/actions/play-actions";
import * as VideoActions from "../../store/actions/video-actions";

import {
  getBookSubtitles,
  getBookType,
  getControlsVisibility,
  getCurrentTime,
  getGalleryVisibility,
  getIsAudioBook,
  getIsPlayerReady,
  getIsPlaying,
  getRealDuration,
  getSubtitlesVisibility,
  getViewMode,
  getVolume,
} from "../../store/selectors/selectors";

import { isIE } from "../../tools/utils";
import "./style.scss";

const {
  VIEWER_MODES: {
    WATCH_MODE
  }
} = AppConfig;
// window.Hls = Hls;
class HlsVideoPlayer extends Component {
  player = null;
  logger = null;
  timeBeforeUrlUpdated = null;

  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      isBuffering: false,
      subtitleText: '',
      subtitlesSet: false,
      isLastSlide: false,
    };
    this.logger = Logger.get("HlsVideoPlayer");
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.url && this.props.url !== prevProps.url) {
      this.timeBeforeUrlUpdated = prevProps.currentTime;
    }

    if (this.props.viewMode === 'audio' && this.state.subtitleText){
      this.setState({ subtitleText: ''})
    }
  }

  getSubtitle = () => {
    if (!isIE) {
      //  get objects associated with the video, track, and div elements
      let trackElements = document.querySelectorAll("track");
      if (trackElements.length) {
        this.setState({ subtitlesSet: true });
        trackElements.forEach(trackRef => {
          trackRef.addEventListener("cuechange", (event) => {
            this.setSubtitle(event.target.track);
          }, false);
        })
      }
    }
  }

  setSubtitle = track => {
    const { activeCues } = track;      // activeCues is an array of current cues.
    track.mode = 'hidden';
    if (activeCues.length > 0) {
      this.setState({ subtitleText: activeCues[0].text });
    } else this.setState({ subtitleText: ''});
  }

  handlePlay = () => {
    this.props.togglePlay(true);
  }

  handlePause = () => {
    this.props.togglePlay(false);
  }

  handleEnded = () => {
    this.setState({ subtitleText: null });
    this.props.bookEnded();

    // just for refresh view and hide the subtitles
    if (this.props.subtitlesVisibility) {
      this.setState({
        isLastSlide: true
      });
    }
  }

  handleSeek = () => {
    if (this.props.isPlaying) {
      this.props.togglePlay(true);
    }
  }

  handleProgress = ({ playedSeconds, played, loadedSeconds, loaded }) => { // timeupdate // progress
    if (playedSeconds > 0) {
      this.props.updateTimeDuringPlayback(playedSeconds)
    }
  }

  handleError = (error, data, thisHls, hls) => {

    if (error === 'hlsError' && process.env.NODE_ENV === 'development') {
      console.log('data - ', data)
    }

    if (data && data.details === 'bufferAppendError') {

    }

    if (error.name === 'NotAllowedError') {
      this.props.togglePlay(false);
      this.props.startedWatch(false);
    }
  }

  handleDuration = (duration) => {
    this.props.initRealDuration(duration)
  }

  handleBuffering = () => {
    this.setState({
      isBuffering: true
    })
  }

  handleBufferEnd = () => {
    this.setState({
      isBuffering: false
    })
  }

  handleReady = () => {
    if (!this.props.isPlayerReady) {
      this.props.onReady();
      const seekTo = this.player.seekTo;
      this.props.savePlayer({seekTo});
      this.getSubtitle();
    }

    if (this.timeBeforeUrlUpdated) {
      this.player.seekTo(this.timeBeforeUrlUpdated);
      this.timeBeforeUrlUpdated = null;
    }
  }

  ref = player => {
    this.player = player
  }

  render() {
    const {
      subtitlesUrl
    } = this.props;

    const {
      controlsVisibility,
      subtitlesVisibility,
      galleryVisibility,
      activeFrame,
      viewMode,
      url,
      volume,
      isPlaying,
      playbackRate,
    } = this.props;
    const wrapperClassName = 'video-player-wrapper'

    const showSubtitles =
      !galleryVisibility &&
      subtitlesVisibility &&
      viewMode === WATCH_MODE &&
      activeFrame > -1 &&
      this.state.subtitleText;

    const isHidden = viewMode !== WATCH_MODE;

    return (
      <div
        className={cx(
          wrapperClassName,
          {
            [`${wrapperClassName}--hidden`]: isHidden,
            [`${wrapperClassName}--is-transparent`]: activeFrame === -1,
          }
        )}
      >
        <div
          className={cx(
            'video_subtitles',
            {
              active: showSubtitles,
              'slide-down': !controlsVisibility
            }
          )}
        >
          {this.state.subtitleText}
        </div>
        {!isIOS && this.state.isBuffering && <div className="loading-container"><LoadingSpinner /></div>}

        <ReactPlayer
          playsinline
          ref={this.ref}
          url={url}
          width="100%"
          height="100%"
          onPlay={this.handlePlay}
          onPause={this.handlePause}
          onEnded={this.handleEnded}
          onSeek={this.handleSeek}
          onProgress={this.handleProgress}
          onError={this.handleError}
          onDuration={this.handleDuration}
          onReady={this.handleReady}
          onBuffer={this.handleBuffering}
          onBufferEnd={this.handleBufferEnd}
          playing={isPlaying}
          playbackRate={playbackRate}
          volume={volume}
          config={{
            file: {
              hlsOptions: {
                maxBufferLength: 3,
                maxBufferSize: 2 * 1024 * 1024
              },
              tracks: [{
                kind: 'subtitles',
                src: subtitlesUrl || '',
                srcLang: 'en',
                default: true
              }],
              attributes: {
                crossOrigin: 'anonymous'
              }
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    controlsVisibility: getControlsVisibility(state),
    galleryVisibility: getGalleryVisibility(state),
    realDuration: getRealDuration(state),
    subtitlesVisibility: getSubtitlesVisibility(state),
    isPlaying: getIsPlaying(state),
    volume: getVolume(state),
    currentTime: getCurrentTime(state),
    subtitlesUrl: getViewMode(state) === 'video' ? getBookSubtitles(state) : false,
    isPlayerReady: getIsPlayerReady(state),
    isFilm: (getBookType(state) === 'film'),
    isAudioBook: getIsAudioBook(state),
    viewMode: getViewMode(state),
    playbackRate: state.app.playbackRate,
  }
};

export default connect(mapStateToProps, { ...Actions, ...VideoActions, ...PlayActions })(HlsVideoPlayer)


// WEBPACK FOOTER //
// ./src/containers/videojs-hls/VideojsHLS.jsx